var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarSignout1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sign Out Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7747 22.6999L26.3371 17.3765C26.555 17.128 26.6665 16.8142 26.6666 16.4988C26.6667 16.283 26.6147 16.0664 26.5091 15.8694C26.4621 15.7816 26.4047 15.6982 26.3371 15.6211L21.7747 10.2977C21.2955 9.7386 20.4538 9.6738 19.8947 10.153C19.3356 10.6322 19.2708 11.4739 19.75 12.0331L22.4345 15.1654L12.1083 15.1654C11.3719 15.1654 10.775 15.7623 10.775 16.4987C10.775 17.2351 11.3719 17.832 12.1083 17.832L22.4347 17.8321L19.75 20.9646C19.2708 21.5237 19.3356 22.3654 19.8947 22.8446C20.4538 23.3238 21.2955 23.259 21.7747 22.6999ZM13.3333 8.4987C14.0697 8.4987 14.6666 9.09565 14.6666 9.83203L14.6666 11.832C14.6666 12.5684 15.2636 13.1654 16 13.1654C16.7363 13.1654 17.3333 12.5684 17.3333 11.832L17.3333 9.83203C17.3333 7.62289 15.5424 5.83203 13.3333 5.83203L9.33329 5.83203C7.12415 5.83203 5.33329 7.62289 5.33329 9.83203L5.33329 23.1654C5.33329 25.3745 7.12415 27.1654 9.33329 27.1654L13.3333 27.1654C15.5424 27.1654 17.3333 25.3745 17.3333 23.1654L17.3333 21.1654C17.3333 20.429 16.7363 19.832 16 19.832C15.2636 19.832 14.6666 20.429 14.6666 21.1654L14.6666 23.1654C14.6666 23.9017 14.0697 24.4987 13.3333 24.4987L9.33329 24.4987C8.59691 24.4987 7.99996 23.9017 7.99996 23.1654L7.99996 9.83203C7.99996 9.09565 8.59691 8.4987 9.33329 8.4987L13.3333 8.4987Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarSignout1);
export default __webpack_public_path__ + "static/media/sidebar_signout1.b473de20bf5dbe563877275c25d0de53.svg";
export { ForwardRef as ReactComponent };